const styles = (theme) => ({
  root: {},
  content: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
    justifyContent: 'space-between',
    minHeight: 65,
    [theme.breakpoints.up('md')]: {
      padding: '20px',
    },
  },
  heading: {
    marginLeft: theme.spacing.unit * 1.5,
    fontSize: '1.25rem',
    [theme.breakpoints.up('sm')]: {
      marginLeft: '20px',
      fontSize: '1.5rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.625rem',
    },
  },
  body: {
    marginLeft: theme.spacing.unit * 1.5,
    fontSize: '1.0625rem',
    [theme.breakpoints.up('sm')]: {
      marginLeft: '20px',
      fontSize: '1.125rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.1875rem',
    },
    '& > strong': {
      fontWeight: 600,
    },
  },
  left: {
    display: 'flex',
    alignItems: 'center',
  },
  avatarBase: {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: theme.palette.border.lighter,
    borderRadius: '100px',
    padding: theme.spacing.unit,
    height: 22,
    width: 22,
    boxSizing: 'content-box',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing.unit * 2,
      height: 30,
      width: 30,
    },
  },
  avatar: {
    color: theme.palette.custom.maintenance,
  },
  chevron: {
    width: 28,
    height: 28,
    [theme.breakpoints.up('lg')]: {
      width: 35,
      height: 35,
    },
  },
});

export default styles;
